import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-view',
  templateUrl: './no-view.component.html',
  styleUrls: ['./no-view.component.css']
})
export class NoViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
